import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left content-container flex-wrap gap-y-4" }
const _hoisted_2 = { class: "bold-text" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "bold-text" }


import { useI18n } from "vue-i18n";
import { PremiumCalculator } from "@/types/premiumTypes";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionCard',
  props: {
    subscriptionName: {}
  },
  emits: ["showSubscribeModal"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(`subscription.${__props.subscriptionName}.name`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("subscription.plans.free")), 1),
      _createElementVNode("button", {
        class: "bg-orange-gradient text-white px-4 py-2 rounded-full max-[422px]:w-full max-[422px]:h-11",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('showSubscribeModal')))
      }, _toDisplayString(_unref(t)("buttons.subscription.get-subscription")), 1)
    ])
  ]))
}
}

})